import React from 'react';
import styles from './FullBackgroundImgArticleCard.module.scss';

import Image from 'next/image';
import Container from 'components/container';
import { Heading, Body } from 'components/text';

import type { ArticleCardTypeProps } from '../types';

const FullBackgroundImgArticleCard: React.FC<ArticleCardTypeProps> = ({
  article,
}) => {
  const { title, header_image, introduction, categories } = article;

  return (
    <Container className={styles.container}>
      <Container className={styles.imageContainer}>
        <div className={styles.cardHeader}>
          <div className={styles.categories}>
            {categories?.map((category, index) => (
              <Body key={index} color="white" weight="demiBold">
                {category.name}
              </Body>
            ))}
          </div>
          <Heading as="h4" color="white">
            {title}
          </Heading>
          <div className={styles.introduction}>
            <Body color="white" fontSize={18}>
              {introduction}
            </Body>
          </div>
        </div>
        <Image
          src={header_image}
          layout="fill"
          objectPosition="center"
          objectFit="cover"
          alt={title}
          sizes="200vw"
        />
        <Container className={styles.bottomGradient} />
      </Container>
    </Container>
  );
};

export default FullBackgroundImgArticleCard;
